import React from 'react';
import PropTypes from 'prop-types';

export default function Modal({
   isModalActive,
   modalTitle,
   actionCancel,
   actionSubmit,
   buttonLabel,
   children,
   isLoading,
}) {
   return (
      <div className={`modal ${isModalActive ? 'is-active' : ''}`}>
         <div className='modal-background'></div>
         <div className='modal-content has-background-white'>
            <div>{children}</div>
            <div
               className='mb-3'
               style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
               <button className='button is-link is-small' onClick={actionSubmit}>
                  {buttonLabel}
               </button>
            </div>
         </div>
         <button
            className='modal-close is-large'
            aria-label='close'
            onClick={actionCancel}
         ></button>
      </div>
   );
}

Modal.propTypes = {
   title: PropTypes.string,
   renderContent: PropTypes.func,
   isModalActive: PropTypes.bool,
   actionCancel: PropTypes.func,
   actionSubmit: PropTypes.func,
   buttonLabel: PropTypes.string,
};
